<template>
  <el-select
    style="width: 100%"
    v-model="localValue"
    :size="size"
    :multiple="multiple"
    :disabled="disabled"
    :clearable="clearable"
    :placeholder="placeholder"
    @change="selected"
    filterable
  >
    <el-option
      v-for="formula in formulas"
      v-if="formula.name"
      :key="formula.id"
      :label="formula.name"
      :value="formula.id"
    />
  </el-select>
</template>

<script>
export default {
  name: "talent-matrix-axis-formula-select",
  props: {
    value: '',
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: true },
    clearable: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Формулы' },
    size: {type: String, default: '' },
  },
  data() {
    return {
      localValue: this.value,
      formulas: [
        {'id': 'sum', 'name': 'Сумма компетенций'},
        {'id': 'average', 'name': 'Среднее значение компетенций'}
      ]
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
  },
  methods: {
    selected(value) {
      if (value === '') {
        value = null;
      }

      this.localValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
};
</script>

<style scoped>

</style>
